import { MoveGenerator } from '../../jscaip/AI/AI';
import { QuartoMove } from './QuartoMove';
import { QuartoPiece } from './QuartoPiece';
export class QuartoMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const listMoves = [];
        const state = node.gameState;
        const board = state.getCopiedBoard();
        const pawns = state.getRemainingPieces();
        const inHand = state.pieceInHand;
        let nextBoard;
        for (let y = 0; y < 4; y++) {
            for (let x = 0; x < 4; x++) {
                if (board[y][x] === QuartoPiece.EMPTY) {
                    nextBoard = state.getCopiedBoard();
                    nextBoard[y][x] = inHand; // the piece we have in hand is put in (x, y)
                    if (state.turn === 15) {
                        const move = new QuartoMove(x, y, QuartoPiece.EMPTY);
                        listMoves.push(move);
                        return listMoves;
                    }
                    // For each empty square
                    for (const remainingPiece of pawns) { // the piece we will give
                        const move = new QuartoMove(x, y, remainingPiece); // this is the move
                        listMoves.push(move);
                    }
                }
            }
        }
        return listMoves;
    }
}
